import React from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const modules = [
  {
    key: 'roundrobin',
    label: 'Round-Robin',
    description: 'Automatically assign Zendesk tickets to agents using configurable round-robin rules.',
    icon: '\u21BB',
    path: '/roundrobin',
  },
  {
    key: 'survey',
    label: 'Survey',
    description: 'Create and manage customer satisfaction surveys integrated with Zendesk.',
    icon: '\uD83D\uDCCB',
    path: '/survey',
  },
];

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const enabledModules = user?.modules || [];

  return (
    <div>
      <div className="mb-4">
        <h4 style={{ fontWeight: 700, color: '#0f172a' }}>
          Welcome, {user?.name || user?.email}
        </h4>
        <p style={{ color: '#64748b', fontSize: '0.9rem' }}>
          Select a module to get started
        </p>
      </div>

      <Row className="g-3">
        {modules.map((mod) => {
          const enabled = enabledModules.includes(mod.key);
          return (
            <Col md={6} lg={4} key={mod.key}>
              <Card
                className={`h-100 ${enabled ? 'module-card-enabled' : 'module-card-disabled'}`}
                style={{
                  cursor: enabled ? 'pointer' : 'default',
                  opacity: enabled ? 1 : 0.5,
                  transition: 'all 0.2s ease',
                }}
                onClick={() => enabled && navigate(mod.path)}
              >
                <Card.Body className="d-flex flex-column">
                  <div className="d-flex align-items-center mb-3">
                    <span style={{ fontSize: '2rem', marginRight: 12 }}>{mod.icon}</span>
                    <div>
                      <Card.Title
                        style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: 2 }}
                      >
                        {mod.label}
                      </Card.Title>
                      <Badge bg={enabled ? 'success' : 'secondary'}>
                        {enabled ? 'Enabled' : 'Not Enabled'}
                      </Badge>
                    </div>
                  </div>
                  <Card.Text style={{ color: '#64748b', fontSize: '0.85rem', flex: 1 }}>
                    {mod.description}
                  </Card.Text>
                  {enabled && (
                    <div className="text-end mt-2">
                      <span
                        style={{
                          color: '#6366f1',
                          fontWeight: 600,
                          fontSize: '0.85rem',
                        }}
                      >
                        Open &rarr;
                      </span>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
